export const environment = {
  production: true,
  debug_mode: false,  
  version: "1.0.25027",
  auth_authority: "",
  auth_redirect_uri: "",
  auth_post_logout_redirect_uri: "",
  auth_client_id: "ui-web-app",
  auth_scope: "openid profile organization auth-api communication-api ocm-api recalls-api",
  test_token: "",
  userflow_token: "ct_c4hv4bul6bccpb3wbqynarvu7i",
  freshdesk_widget_id:"#{freshdesk_widget_id}#",

  appConfig: {
    identity_api_url: "#{identity_api_url}#",
    oc_api_url: "#{oc_api_url}#",
    signalR_url:"#{signalR_url}#",
    comm_api_url: "#{comm_api_url}#",
    reminders_api_url: "#{reminders_api_url}#",    
    reports_api_url: "#{reports_api_url}#",
    reports_migration_url: "#{reports_migration_url}#",
    recalls_api_url: "#{recalls_api_url}#",
    appInsightsInstrumentationKey: "#{appInsightsInstrumentationKey}#",
    survey_service_api_url: "#{survey_service_api_url}#",
    dentally_integration_url: "#{dentally_integration_url}#",
    dentally_client_id: "#{dentally_client_id}#",
    dentally_scopes: "user:read appointment:read patient:read practice treatments", // this is global hard-coded on purpose. Do not convert it into a configurable value in the pipeline. This will never change unless globally in response to a change to Dentally. This does not need to be configurable in the pipeline.
    amplitude_key: "#{amplitude_key}#",
    heap_key: "#{heap_key}#",
    curnex_api_url:"#{curnex_api_url}#",
    curnex_integration_url: "#{curnex_integration_url}#",
    patient_leads_url: "#{patient_leads_url}#"
  },

  //MSAL
  msal: {
    clientId: "#{msal:clientId}#",
    tenantId:"#{msal:tenantId}#",
    signinAuthority: "#{msal:authority}#",
    resetPasswordAuthority: "#{msal:reset-password-authority}#",
    redirectUri: "#{msal:redirectUri}#",
    logOutUri:"#{msal:logOutUri}#",
    knownAuthorities: ["#{msal:knownAuthorities}#"],
    protectedResources: {
      ocmApi: {
        endpoint: "#{msal:ocm-endpoint}#",
        scopes: ["#{msal:ocm-scopes}#"],
      },
      reportApi: {
        endpoint: "#{msal:report-endpoint}#",
        scopes: ["#{msal:report-scopes}#"],
      },
      authApi:{
        endpoint: "#{msal:auth-endpoint}#",
        scopes: ["#{msal:auth-scopes}#"],
      },
      chatApi:{
        endpoint: "#{msal:chat-endpoint}#",
        scopes: ["#{msal:curnex-scopes}#"],
      },
      curnexApi:{
        endpoint:"#{msal:curnex-endpoint}#",
        scopes:["#{msal:curnex-scopes}#"],
      }
    }
  },

  //APIs.
  oc_api_visit_types_url: "api/visittypes",
  oc_api_members_url: "api/members/",
  oc_api_appointments_url: "api/appointments/",
  oc_api_centers_url: "api/centers/",
  oc_api_organizations_url: "api/organizations/",
  oc_api_available_domains_url: "api/availableDomains",
  oc_api_procedure_protocols_url: "api/procedureprotocols/",
  oc_api_referrals_url: "api/referrals/",
  oc_api_storage_url: "api/storage/",
  oc_api_groupcategories_url: "api/groupcategories/",
  oc_api_organization_import_settings_url: "api/organizationimportsettings/",
  oc_api_org_subscriptions: "api/OrganizationSubscription/",
  oc_api_org_product: "api/OrganizationSubscription/product-info/",
  oc_passive_mode_url:"/CheckPassiveMode",
  comm_api_surveys: "api/surveys/",
  comm_api_email_templates_url: "api/emailtemplates/",
  comm_api_send_messages_url: "api/sendmessages/",
  reports_api_performances_url: "api/performances/",
  reports_api_data_exports_url: "api/dataexports/",
  reports_api_dashboard_url: "api/dashboard/",
  reports_api_settings_url: "api/settings/",
  reports_api_data_migrations_url: "api/data-migrations/",
  reminders_api_microsites_url: "api/microsite/",
  reminders_api_campaigns_url: "api/campaigns/",
  reminders_api_settings_url: "api/settings/",
  reminders_api_appointments_url: "api/appointments/",
  
  identity_api_organizations_url: "api/organizations/",
  identity_api_passwordpolicy_url: "api/passwordpolicy/",
  identity_api_passworddefaultpolicy_url: "api/passwordpolicy/default",
  identity_api_upload_common_passwords_url: "api/passwordpolicy/upload/common/",
  identity_api_remove_common_passwords_url: "api/passwordpolicy/remove/common/",  
  identity_api_claims: "api/webapp-claims",  
  identity_api_list_applications: "api/secret-management/application/list",
  identity_api_add_application: "api/secret-management/application/add",
  identity_api_delete_application: "api/secret-management/application/delete",
  identity_api_list_secrets: "api/secret-management/secret/list",
  identity_api_add_secret: "api/secret-management/secret/add",
  identity_api_delete_secret: "api/secret-management/secret/delete",
  curnex_skip_step:"entities/",

  recalls_api_settings_url(orgId: string) {
    return `api/${orgId}/settings/`;
  },
  recalls_api_content_url(orgId: string) {
    return `api/${orgId}/content/`;
  },
};

